import React from 'react';
import {Box, Grid, IconButton, Typography} from "@mui/material";
import mission from '../../../../assets/images/Mission.png';
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {GetState} from "../../../../redux/reduxhelper";
import {IS_AUTH} from "../../../../redux/action/type.action";
import {useNavigate} from "react-router";
import {getVisionInfoApi} from "../../../../api/ClientApi";
import {useQuery} from "react-query";
import Loading from "../../../../components/Site/Loading/Loading";
import {escapedNewLineToLineBreakTag} from "../../../../tools/helper";

const OurTarget = () => {
    const isAuth = GetState(IS_AUTH, false)
    const navigate = useNavigate();


    const getVisionInfo = async () => {
        try {
            const res = await getVisionInfoApi()
            return res?.data?.data
        } catch (e) {
            //console.log(e)
        }
    }

    const {
        isLoading,
        data: ourTarget,
    } = useQuery(['our_target'], getVisionInfo);

    if (isLoading) return <Loading/>;

    let description = ourTarget?.description.replace(/\\\\n/g, "<br/>").replaceAll('&zwnj;','');
    return (
        <Box sx={{
            width: '100vw',
            display: 'flex',
            flexDirection: "column",
            minHeight: '650px',
            alignItems: 'center',
            justifyContent: 'center',
            mb: {md: 15, xs: 2}
        }}>
            <Grid sx={{
                display: "block",
                position: {md: "relative", xs: "static"},
                maxWidth: '1300px',
                justifyContent: "space-between",
                alignItems: "center",
                marginY: 5,
                width: "100vw",

            }}>


                <Grid sx={{width: {xs: "100%", md: "60%"}}}>
                    <img src={mission} alt="logo" style={{width: "100%"}}/>
                </Grid>

                <Grid sx={{
                    background: "#F4F0F8",
                    position: {md: "absolute", xs: "static"},
                    right: "14%",
                    top: "18%",
                    bottom: "-18%",
                    width: {md: "50%", xs: "100%"},
                    minHeight: "110%",
                    overflowY: {xs: 'none', md: 'scroll'},
                    p: 3
                }}>
                    {isAuth && <Grid sx={{textAlign: "right"}}>
                        <IconButton sx={{color: "#592EA9", cursor: "pointer"}}
                                    onClick={() => navigate('admin/dashboard/our-target')}>
                            <EditOutlinedIcon/>
                        </IconButton>
                    </Grid>}
                    <Typography variant={"h5"}
                                sx={{color: "#4C4C4C", fontWeight: 700, p: 1}}>
                        {ourTarget?.title1}
                    </Typography>
                    <Typography variant={"h6"}
                                sx={{color: "#592EA9", fontWeight: 700, p: 1}}>
                        {ourTarget?.title2}
                    </Typography>
                    <Typography dangerouslySetInnerHTML={{
                        __html: escapedNewLineToLineBreakTag(description)
                    }} sx={{color: "#6D6E76", fontSize: 17, lineHeight:1.7}}/>
                </Grid>


            </Grid>
        </Box>
    );
};

export default OurTarget;